import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { AuthProvider } from "@/context/AuthContext";
import { ProtectedRoute } from "@/components/ProtectedRoute";
import { AppLayout } from "@/components/AppLayout";
import LoginPage from "@/pages/Login";
import DashboardPage from "@/pages/Dashboard";
import UploadPage from "@/pages/UploadPage";
import { BatchesPage, BatchDetailPage } from "@/pages/BatchesPage";
import { PartiesPage, PartyDetailPage } from "@/pages/PartiesPage";
import { InvoicesPage } from "@/pages/InvoicesPage";
import TemplatesPage from "@/pages/TemplatesPage";
import ReconciliationPage from "@/pages/ReconciliationPage";
import AuditPage from "@/pages/AuditPage";
import SettingsPage from "@/pages/SettingsPage";
import { Toaster } from "sonner";

function App() {
  return (
    <div className="App">
      <AuthProvider>
        <BrowserRouter>
          <Toaster position="top-right" richColors />
          <Routes>
            <Route path="/login" element={<LoginPage />} />
            <Route
              path="/"
              element={
                <ProtectedRoute>
                  <AppLayout />
                </ProtectedRoute>
              }
            >
              <Route index element={<DashboardPage />} />
              <Route path="upload" element={<ProtectedRoute roles={["admin", "operator"]}><UploadPage /></ProtectedRoute>} />
              <Route path="batches" element={<BatchesPage />} />
              <Route path="batches/:id" element={<BatchDetailPage />} />
              <Route path="parties" element={<PartiesPage />} />
              <Route path="parties/:id" element={<PartyDetailPage />} />
              <Route path="invoices/drafts" element={<InvoicesPage status="draft" />} />
              <Route path="invoices/approved" element={<InvoicesPage status="approved" />} />
              <Route path="templates" element={<TemplatesPage />} />
              <Route path="reconciliation" element={<ReconciliationPage />} />
              <Route path="audit" element={<ProtectedRoute roles={["admin", "reviewer"]}><AuditPage /></ProtectedRoute>} />
              <Route path="settings" element={<ProtectedRoute roles={["admin"]}><SettingsPage /></ProtectedRoute>} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </AuthProvider>
    </div>
  );
}

export default App;
